import { CreateDisplayConditionController } from './create.controller';

const createHtml = require('./create.html');

/* @ngInject */
export function createDisplayConditionDirective(RecursionHelper): angular.IDirective {
  return {
    restrict: 'E',
    scope: {
      models: '=',
      label: '=',
      buttonLabel: '=',
      isRootCondition: '='
    },
    templateUrl: createHtml,
    controller: CreateDisplayConditionController,
    controllerAs: 'fdCreateCtrl',
    compile: (element) => RecursionHelper.compile(element, () => void 0)
  };
}
